var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDialerAnswer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 109 109"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 54.5,
    r: 51.5,
    fill: "#38CF46",
    stroke: "#38CF46"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M68.8 81.337c-4.518 0-9.323-1.283-14.28-3.8-4.574-2.328-9.092-5.659-13.06-9.643-3.977-3.976-7.3-8.495-9.627-13.077-2.518-4.956-3.801-9.761-3.801-14.28 0-2.924 2.725-5.753 3.897-6.837 1.689-1.554 4.343-3.363 6.271-3.363.956 0 2.08.63 3.538 1.976 1.084 1.005 2.303 2.367 3.53 3.937.733.948 4.407 5.785 4.407 8.112 0 1.905-2.152 3.228-4.43 4.63-.885.542-1.794 1.1-2.455 1.634-.701.565-.829.86-.853.924 2.423 6.032 9.818 13.427 15.85 15.85.056-.016.35-.136.925-.853.525-.661 1.091-1.57 1.633-2.454 1.403-2.28 2.725-4.43 4.63-4.43 2.327 0 7.164 3.673 8.112 4.414 1.57 1.22 2.933 2.438 3.937 3.53C78.37 69.057 79 70.181 79 71.137c0 1.929-1.809 4.59-3.363 6.28-1.084 1.179-3.912 3.92-6.837 3.92z"
  }))));
}

export default SvgDialerAnswer;